import { useHandler } from "@redotech/react-util/hook";
import { StringCompareOperators } from "@redotech/redo-model/segments/segment-where-condition";
import { memo } from "react";
import { RedoTextInput } from "../../../arbiter-components/input/redo-text-input";
import { RedoListItem } from "../../../arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "../../../arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { StringCompareInProgress } from "../segment-in-progress";

const stringCompareOperatorToFriendly: Record<StringCompareOperators, string> =
  {
    [StringCompareOperators.CONTAINS]: "contains",
    [StringCompareOperators.NOT_CONTAINS]: "does not contain",
    [StringCompareOperators.STARTS_WITH]: "starts with",
    [StringCompareOperators.ENDS_WITH]: "ends with",
  };

const stringCompareOperatorOptions: RedoListItem<StringCompareOperators>[] =
  Object.values(StringCompareOperators).map((operator) => ({
    id: operator,
    type: "text",
    text: stringCompareOperatorToFriendly[operator],
    value: operator,
  }));

export const StringFilter = memo(function StringFilter({
  comparison,
  setComparison,
}: {
  comparison: StringCompareInProgress;
  setComparison: (comparison: StringCompareInProgress) => void;
}) {
  const setValue = useHandler((value: string) => {
    setComparison({ ...comparison, value: value || undefined });
  });

  return (
    <>
      <RedoSingleSelectDropdownInput<StringCompareOperators>
        fitToAnchor={false}
        flexGrow={false}
        options={stringCompareOperatorOptions}
        optionSelected={({ item }) => {
          setComparison({ ...comparison, operator: item.value });
        }}
        selectedItem={stringCompareOperatorOptions.find(
          (o) => o.value === comparison.operator,
        )}
        size="xs"
      />
      <RedoTextInput
        setValue={setValue}
        size="sm"
        value={comparison.value ?? ""}
      />
    </>
  );
});
